import { render } from "./FriendsListPopup.vue?vue&type=template&id=2ba2d10f&scoped=true"
import script from "./FriendsListPopup.vue?vue&type=script&lang=js"
export * from "./FriendsListPopup.vue?vue&type=script&lang=js"

import "./FriendsListPopup.vue?vue&type=style&index=0&id=2ba2d10f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba2d10f"]])

export default __exports__